import { render, staticRenderFns } from "./Block2.vue?vue&type=template&id=50d70425&scoped=true&"
import script from "./Block2.vue?vue&type=script&lang=js&"
export * from "./Block2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d70425",
  null
  
)

export default component.exports